import { Card, Collapse } from '@mui/material';
import { Stack } from '@mui/material';
import { ReactNode } from 'react';
import {
  ReportSectionCardHeader,
  ReportSectionCardHeaderProps,
} from './ReportSectionCardHeader';

type ReportSectionCardProps = ReportSectionCardHeaderProps & {
  children: ReactNode;
};

export const ReportSectionCard = (props: ReportSectionCardProps) => {
  const { children, ...headerProps } = props;

  return (
    <Card
      elevation={0}
      variant="outlined"
      sx={{ paddingX: '14px', paddingY: '12px' }}
    >
      <Stack spacing={2}>
        <ReportSectionCardHeader {...headerProps} />
        <Collapse in={!props.editable || props.includedInReport}>
          {children}
        </Collapse>
      </Stack>
    </Card>
  );
};
